import { useEffect, useState } from "react";
import { CoreType } from '../Shared/CoreComponents';
import {
    Button,
    Col,
    Divider,
    Row,
    Select,
    Text,
} from '@servahealth/serva-ui-kit';

export interface AHRBCoreTypeRootSelectionProps {
    ahReportGroupName: string;
    ahReportName: string;
    typesInDataPoints: CoreType[];
    initialSelectedCoreTypeRootId: number | undefined;
    handleSetCoreTypeRootSelection: (
        selectedCoreTypeRoot: CoreType
    ) => void;
    onOk: (
        selectedCoreTypeRoot: CoreType
    ) => void;
    onCancel: () => void;
}

export const AHRBCoreTypeRootSelection: React.FC<AHRBCoreTypeRootSelectionProps> = ({ ...props }) => {

    const {typesInDataPoints, initialSelectedCoreTypeRootId} = props;
    const [selectedCoreTypeRootId, setSelectedCoreTypeRootId] = useState<number | undefined>(props.initialSelectedCoreTypeRootId);

    useEffect(() => {
        if (initialSelectedCoreTypeRootId !== undefined) {
            let initialSelectedCoreType = typesInDataPoints.find(x => x.id === initialSelectedCoreTypeRootId);

            if (initialSelectedCoreType)
            {
                setSelectedCoreTypeRootId(initialSelectedCoreType.id);
            }
        }
    }, [typesInDataPoints, initialSelectedCoreTypeRootId]);

    const handleCoreTypeRootChange = (value: number) => {
        setSelectedCoreTypeRootId(value);

        const selectedCoreTypeRoot = props.typesInDataPoints.find(
            typeInDataPoint => typeInDataPoint.id === value
        );

        if (selectedCoreTypeRoot) {
            props.handleSetCoreTypeRootSelection(selectedCoreTypeRoot);
        }
    };

    const contentStyle: React.CSSProperties = {
        lineHeight: '95%',
        textAlign: 'center',
        color: 'black',
        backgroundColor: 'azure',
        borderRadius: '10',
        border: `1px solid black`,
        marginTop: 4,
        height: '95%'
    };

    return (
        <>
            <Row gutter={16} className='retainbi-compact-row'>
                <Col span={4} />
                <Col span={16}>
                    <div style={contentStyle}>
            			<h3 className='text-2xl pt-2 px-2'>Parent Object Type</h3>
                    </div>
                </Col>
                <Col span={4} />
            </Row>
            <Row gutter={16} className='retainbi-compact-row'>
                <Col span={1} />
                <Col span={22}>
                    <div>
                        <Divider style={{ borderTop: '1px solid black', margin: '1px' }}></Divider>
                    </div>
                </Col>
                <Col span={1} />
            </Row>
            <Row gutter={16} className='retainbi-compact-row'>
                <Col span={1} />
                <Col span={11}>
                    <Text italic strong>Report Group:</Text>{" "}
                    <Text>{props.ahReportGroupName}</Text>
                </Col>
                <Col span={11}>
                    <Text italic strong>Report Name:</Text>{" "}
                    <Text>{props.ahReportName}</Text>
                </Col>
                <Col span={1} />
            </Row>
            <Row gutter={16} className='retainbi-compact-row'>
                <Col span={24}>
                    <div>
                        <Divider style={{ margin: '1px' }}></Divider>
                    </div>
                </Col>
            </Row>
            <Row gutter={16} className='retainbi-compact-row'>
                <Col span={24}>
                    <Text italic strong>Select The Parent Object Type:</Text>
                    <Select
                        style={{ width: '100%', marginTop: '8px' }}
                        placeholder='Select A Parent Object Type'
                        value={selectedCoreTypeRootId}
                        onChange={handleCoreTypeRootChange}
                    >
                        {props.typesInDataPoints.map(typeInDataPoint => (
                            <Select.Option
                                key={typeInDataPoint.id}
                                value={typeInDataPoint.id}
                            >
                                {typeInDataPoint.name}
                            </Select.Option>
                        ))}
                    </Select>
                </Col>
            </Row>
            <Row gutter={16} className='retainbi-compact-row'>
                <Col span={15} />
                <Col span={4}>
                    <div style={{ textAlign: 'right' }}>
                            <Button
                                disabled={selectedCoreTypeRootId === undefined}
                                htmlType="submit"
                                style={{width: '95%'}}
                                type='primary'
                                onClick={() => {
                                    const selectedCoreTypeRoot = props.typesInDataPoints.find(
                                        typeInDataPoint => typeInDataPoint.id === selectedCoreTypeRootId
                                    );

                                    if (selectedCoreTypeRoot) {
                                        props.onOk(selectedCoreTypeRoot);
                                    }
                                }}
                            >
                                OK
                            </Button>
                    </div>
                </Col>
                <Col span={4}>
                    <div style={{ textAlign: 'right' }}>
                            <Button
                                style={{width: '95%'}}
                                type="default"
                                onClick={() => props.onCancel()}
                            >
                                Cancel
                            </Button>
                    </div>
                </Col>
                <Col span={1} />
            </Row>
        </>
    );
};

export default AHRBCoreTypeRootSelection;